import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:5043/api';
export interface PhotoUploadResponse {
  userId: string;
  photoUrl: string;
}

// Generate a temporary user ID when server is unavailable
function generateTempUserId(): string {
  return 'temp_' + Math.random().toString(36).substring(2, 15);
}

export async function uploadPhoto(photoBlob: Blob): Promise<PhotoUploadResponse> {
  try {
    console.log('Starting photo upload...');
    console.log('API URL:', API_URL);

    // Convert the blob to base64
    const base64 = await blobToBase64(photoBlob);
    console.log('Photo converted to base64');

    try {
      console.log('Making API request...');
      // Upload to backend
      const response = await axios.post<PhotoUploadResponse>(`${API_URL}/user/create`, {
        photoUrl: base64
      });

      console.log('Upload response:', response.data);
      return response.data;
    } catch (serverError) {
      console.error('Server error, using fallback mode:', serverError);
      // If server is unavailable, create a temporary user ID and store photo locally
      // This allows the app to continue functioning even when the server is down
      const tempUserId = generateTempUserId();
      const tempResponse: PhotoUploadResponse = {
        userId: tempUserId,
        photoUrl: base64
      };
      
      // Store in localStorage for potential future sync
      try {
        localStorage.setItem(`photo_${tempUserId}`, base64);
        console.log('Photo stored locally with temp ID:', tempUserId);
      } catch (storageError) {
        console.error('Failed to store photo locally:', storageError);
      }
      
      return tempResponse;
    }
  } catch (error) {
    console.error('Error in uploadPhoto:', error);
    if (axios.isAxiosError(error)) {
      console.error('Axios error details:', {
        status: error.response?.status,
        data: error.response?.data,
        message: error.message
      });
    }
    throw error;
  }
}

// Helper function to convert Blob to base64
function blobToBase64(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      if (typeof reader.result === 'string') {
        resolve(reader.result);
      } else {
        reject(new Error('Failed to convert blob to base64'));
      }
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}